import { useQuery } from '@apollo/client';

import { useNaptime } from 'bundles/naptimejs';
import ProgramCurriculumsV1 from 'bundles/naptimejs/resources/programCurriculums.v1';

import EnterpriseProgramsV1ResourceSlug from './queries/EnterpriseProgramsV1ResourceSlug.graphql';
import type {
  EnterpriseProgramsV1ResourceSlugQuery,
  EnterpriseProgramsV1ResourceSlugQueryVariables,
} from './queries/__generated__/EnterpriseProgramsV1ResourceSlug';

export const useProgramBySlug = (slug: string) => {
  const { data } = useQuery<EnterpriseProgramsV1ResourceSlugQuery, EnterpriseProgramsV1ResourceSlugQueryVariables>(
    EnterpriseProgramsV1ResourceSlug,
    {
      skip: !slug,
      variables: { slug },
      errorPolicy: 'all', // Dont want to block render in case of an error.
      context: { clientName: 'gatewayGql' },
    }
  );
  return data?.NaptimeQueries.EnterpriseProgramsV1Resource.slug?.elements[0];
};

export const useCurriculum = (curriculumId?: string) => {
  const {
    data: { curriculum },
    pending: naptimePending,
    naptime,
  } = useNaptime<{ curriculum: ProgramCurriculumsV1 }>(
    () => ({
      curriculum: curriculumId
        ? ProgramCurriculumsV1.get(curriculumId, {
            fields: ['definition', 'typeName'],
            params: {
              includeClips: true,
            },
          })
        : undefined,
    }),
    [curriculumId]
  );
  return { curriculum, naptimePending, naptime };
};

export const useCurriculumByProgramSlug = (slug: string) => {
  const program = useProgramBySlug(slug);
  return useCurriculum(program?.metadata.curriculumId);
};
